module.exports = __webpack_public_path__ + "img/bq.2c52a7ba.svg";